module.exports = __webpack_public_path__ + "static/media/logo_port_of_hanko.87629320.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/logo_port_of_hanko.png
// module id = 1419
// module chunks = 0